<div class="container-with-footer">
    <div class="container-fluid" data-cy="personnelDetails">
        <div class="data">
            <span class="display-label">Name</span>{{ person | formatPerson }}
        </div>

        <div class="data">
            <span class="display-label">Email</span>{{ person.email }}
        </div>

        <div class="data">
            <span class="display-label">Phone Number</span
            >{{ person.phoneNumber }}
        </div>

        <ng-container *ngFor="let identifier of jurisdictionIdentifiers">
            <div class="data">
                <span class="display-label">{{ identifier.name }}</span
                >{{ identifier.value }}
            </div>
        </ng-container>

        <div *ngIf="roles" class="data">
            <span class="display-label">Roles</span>{{ roles }}
        </div>

        <div class="data">
            <span class="display-label">Assigned Licences</span
            >{{ assignedLicences }}
        </div>
        <div *ngIf="canUseWorkgroups" class="data">
            <span class="display-label">Workgroups</span>
            {{ workgroups || 'None' }}
        </div>
        <div *ngIf="integrationIdentifiers.length > 0">
            <h4>User's Integrations</h4>
            <enhanced-help
                componentName="configuredIntegrations"
                [compact]="true"
            ></enhanced-help>
            <div
                *ngFor="let integration of integrationIdentifiers"
                class="data"
            >
                <span class="display-label">{{
                    integration | formatOrganisationIntegration
                }}</span>
                {{
                    person.configuredIntegrations[integration] == null
                        ? 'Not Visible'
                        : person.configuredIntegrations[integration]
                        ? 'Configured'
                        : 'Not Configured'
                }}
            </div>
        </div>
    </div>
    <div class="action-container">
        <button
            data-cy="archivePersonnel"
            *ngIf="canEdit && roles != null && roles.length > 0"
            class="btn btn-default pull-left"
            type="button"
            (click)="onArchive()"
        >
            Archive
        </button>
        <print-personnel-reports
            [person]="person"
            [managingOrganisationId]="managingOrganisationId"
        >
        </print-personnel-reports>
        <button
            data-cy="editPersonnelDetails"
            *ngIf="canEdit && roles != null && roles.length > 0"
            class="btn btn-primary"
            type="button"
            (click)="onEdit()"
        >
            Edit
        </button>
    </div>
</div>
